import { render } from "./Knob.vue?vue&type=template&id=823c3bd2&scoped=true"
import script from "./Knob.vue?vue&type=script&lang=js"
export * from "./Knob.vue?vue&type=script&lang=js"

import "./Knob.vue?vue&type=style&index=0&id=823c3bd2&scoped=true&lang=css"

import exportComponent from "/Users/williamconnell/Desktop/Minilogue Project/xdpatch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-823c3bd2"]])

export default __exports__